import { IConfigsType } from '../../types'

const fwSssBreakdownChart: IConfigsType = {
  'fw_wingstop-financial-chart-239cbabf': {
    '/:brand/sss_breakdown': {
      variables: [
        'date',
        'farwestTimeinterval',
        {
          type: 'selectOptions',
          options: {
            orderMode: {
              defaultId: [['net_sales']],
              options: [
                { id: 'net_sales', displayName: 'SSS%' },
                { id: 'check_count', displayName: 'SST%' },
                {
                  id: 'check_average',
                  displayName: 'SSC%',
                },
              ],
            },
          },
        },
      ],
      dateFilter: {
        types: ['year'],
        defaultType: 'year',
      },
      pageTitle: {
        type: 'title',
        title: 'SSS/SST/SSC Breakdown Charts',
      },
      marketChartFilters: {
        type: 'grid',
        children: {
          downloadReport: {
            type: 'download-csv',
            api: 'fwMarketSssBreakdown',
            fileName: 'getexpo-far-west-sss-market-breakdown-charts',
            message: 'Download as CSV',
            fields: [
              {
                key: 'period',
                title: 'Date Period - Metric',
              },
              {
                key: 'fwrgCurrent',
                title: 'FWRG 1Y Data for <%- date?.getInfo(0)?.displayName %>',
                decimal: 4,
              },
              {
                key: 'fwrgTwoYears',
                title:
                  'FWRG 2Y Stacked Data for <%- date?.getInfo(0)?.displayName %>',
                decimal: 4,
              },
              {
                key: 'gdplCurrent',
                title: 'GDPL 1Y Data for <%- date?.getInfo(0)?.displayName %>',
                decimal: 4,
              },
              {
                key: 'gdplTwoYears',
                title:
                  'GDPL 2Y Stacked Data for <%- date?.getInfo(0)?.displayName %>',
                decimal: 4,
              },
              {
                key: 'trgCurrent',
                title: 'TRG 1Y Data for <%- date?.getInfo(0)?.displayName %>',
                decimal: 4,
              },
              {
                key: 'trgTwoYears',
                title:
                  'TRG 2Y Stacked Data for <%- date?.getInfo(0)?.displayName %>',
                decimal: 4,
              },
              {
                key: 'mrgCurrent',
                title: 'MRG 1Y Data for <%- date?.getInfo(0)?.displayName %>',
                decimal: 4,
              },
              {
                key: 'mrgTwoYears',
                title:
                  'MRG 2Y Stacked Data for <%- date?.getInfo(0)?.displayName %>',
                decimal: 4,
              },
              {
                key: 'zrgCurrent',
                title: 'ZRG 1Y Data for <%- date?.getInfo(0)?.displayName %>',
                decimal: 4,
              },
              {
                key: 'zrgTwoYears',
                title:
                  'ZRG 2Y Stacked Data for <%- date?.getInfo(0)?.displayName %>',
                decimal: 4,
              },
            ],
          },
          timeColumns: {
            type: 'select',
            value: 'farwestTimeinterval.value',
            onChange: 'farwestTimeinterval.onChange',
            options: 'farwestTimeinterval.options',
            label: 'Time Interval:',
          },
          revenueColumns: {
            type: 'select',
            value: 'selectOptions.orderMode.value',
            onChange: 'selectOptions.orderMode.onChange',
            options: 'selectOptions.orderMode.options',
            label: 'Channel:',
          },
        },
      },
      marketChart: {
        type: 'bar-chart',
        api: 'fwMarketSssBreakdown',
        width: 1500,
        height: 800,
        label: 'period',
        datasets: [
          {
            chartType: 'line',
            key: 'fwrgCurrent',
            label: 'FWRG 1 Year',
            borderColor: '#666666',
            backgroundColor: '#666666',
          },
          {
            chartType: 'line',
            key: 'fwrgTwoYears',
            label: 'FWRG 2 Years Stacked',
            borderColor: '#AAAAAA',
            backgroundColor: '#AAAAAA',
            hidden: true,
          },
          {
            chartType: 'line',
            key: 'gdplCurrent',
            label: 'GDPL 1 Year',
            borderColor: '#CC0000',
            backgroundColor: '#CC0000',
          },
          {
            chartType: 'line',
            key: 'gdplTwoYears',
            label: 'GDPL 2 Years Stacked',
            borderColor: '#FF8888',
            backgroundColor: '#FF8888',
            hidden: true,
          },
          {
            chartType: 'line',
            key: 'trgCurrent',
            label: 'TRG 1 Year',
            borderColor: '#DDAA00',
            backgroundColor: '#DDAA00',
          },
          {
            chartType: 'line',
            key: 'trgTwoYears',
            label: 'TRG 2 Years Stacked',
            borderColor: '#FFDD55',
            backgroundColor: '#FFDD55',
            hidden: true,
          },
          {
            chartType: 'line',
            key: 'mrgCurrent',
            label: 'MRG 1 Year',
            borderColor: '#66DD00',
            backgroundColor: '#66DD00',
          },
          {
            chartType: 'line',
            key: 'mrgTwoYears',
            label: 'MRG 2 Years Stacked',
            borderColor: '#99FF33',
            backgroundColor: '#99FF33',
            hidden: true,
          },
          {
            chartType: 'line',
            key: 'zrgCurrent',
            label: 'ZRG 1 Year',
            borderColor: '#009FCC',
            backgroundColor: '#009FCC',
          },
          {
            chartType: 'line',
            key: 'zrgTwoYears',
            label: 'ZRG 2 Years Stacked',
            borderColor: '#33FFFF',
            backgroundColor: '#33FFFF',
            hidden: true,
          },
        ],
        scaleTypes: {
          y: {
            type: 'percent',
            beginAtZero: true,
          },
        },
        options: {
          scales: {
            x: {
              ticks: {
                font: {
                  size: 10,
                },
              },
            },
          },
        },
      },
      coreChartFilters: {
        type: 'grid',
        children: {
          downloadReport: {
            type: 'download-csv',
            api: 'fwCoreNoncoreSssBreakdown',
            fileName: 'getexpo-far-west-sss-core-non-core-breakdown-charts',
            message: 'Download as CSV',
            fields: [
              {
                key: 'period',
                title: 'Date Period - Metric',
              },
              {
                key: 'coreCurrent',
                title: 'Core 1Y Data for <%- date?.getInfo(0)?.displayName %>',
                decimal: 4,
              },
              {
                key: 'coreTwoYears',
                title:
                  'Core 2Y Stacked Data for <%- date?.getInfo(0)?.displayName %>',
                decimal: 4,
              },
              {
                key: 'nonCoreCurrent',
                title:
                  'Non-Core 1Y Data for <%- date?.getInfo(0)?.displayName %>',
                decimal: 4,
              },
              {
                key: 'nonCoreTwoYears',
                title:
                  'Non-Core 2Y Stacked Data for <%- date?.getInfo(0)?.displayName %>',
                decimal: 4,
              },
            ],
          },
          timeColumns: {
            type: 'select',
            value: 'farwestTimeinterval.value',
            onChange: 'farwestTimeinterval.onChange',
            options: 'farwestTimeinterval.options',
            label: 'Time Interval:',
          },
          revenueColumns: {
            type: 'select',
            value: 'selectOptions.orderMode.value',
            onChange: 'selectOptions.orderMode.onChange',
            options: 'selectOptions.orderMode.options',
            label: 'Channel:',
          },
        },
      },
      coreChart: {
        type: 'bar-chart',
        api: 'fwCoreNoncoreSssBreakdown',
        width: 1500,
        height: 800,
        label: 'period',
        datasets: [
          {
            chartType: 'line',
            key: 'coreCurrent',
            label: 'Core 1 Year',
            borderColor: '#66DD00',
            backgroundColor: '#66DD00',
          },
          {
            chartType: 'line',
            key: 'coreTwoYears',
            label: 'Core 2 Years Stacked',
            borderColor: '#99FF33',
            backgroundColor: '#99FF33',
            hidden: true,
          },
          {
            chartType: 'line',
            key: 'nonCoreCurrent',
            label: 'Non-Core 1 Year',
            borderColor: '#009FCC',
            backgroundColor: '#009FCC',
          },
          {
            chartType: 'line',
            key: 'nonCoreTwoYears',
            label: 'Non-Core 2 Years Stacked',
            borderColor: '#33FFFF',
            backgroundColor: '#33FFFF',
            hidden: true,
          },
        ],
        scaleTypes: {
          y: {
            type: 'percent',
            beginAtZero: true,
          },
        },
        options: {
          scales: {
            x: {
              ticks: {
                font: {
                  size: 10,
                },
              },
            },
          },
        },
      },
      cohortCountTitle: {
        type: 'typography',
        apiOrContent: 'Store Count by Cohort',
        variant: 'h5',
        margin: '40px 0px 0px',
      },
      cohortCountNote: {
        type: 'typography',
        apiOrContent:
          'Stores that changed cohort within a bar are counted by their status on the last day of the Time Interval.',
        variant: 'body2',
        margin: '4px 0px 0px',
      },
      cohortCountFilters: {
        type: 'grid',
        children: {
          timeColumns: {
            type: 'select',
            value: 'farwestTimeinterval.value',
            onChange: 'farwestTimeinterval.onChange',
            options: 'farwestTimeinterval.options',
            label: 'Time Interval:',
          },
        },
      },
      coreCohortCountChart: {
        type: 'bar-chart',
        api: 'fwCoreNoncoreCohortCount',
        width: 1500,
        height: 500,
        label: 'period',
        datasets: [
          {
            key: 'corePercent',
            label: 'Core',
            tooltipLabelKey: 'coreTooltip',
            decimal: 1,
            borderColor: '#2a78d6',
            backgroundColor: '#2a78d6',
          },
          {
            key: 'nonCorePercent',
            label: 'Non-Core',
            tooltipLabelKey: 'nonCoreTooltip',
            decimal: 1,
            borderColor: '#eb6834',
            backgroundColor: '#eb6834',
          },
        ],
        scaleTypes: {
          y: {
            type: 'percent',
            decimal: 0,
            beginAtZero: true,
          },
        },
        options: {
          scales: {
            x: {
              stacked: true,
              ticks: {
                font: {
                  size: 10,
                },
              },
            },
            y: {
              stacked: true,
              max: 100,
            },
          },
        },
      },
      compCohortCountChart: {
        type: 'bar-chart',
        api: 'fwCompNoncompCohortCount',
        width: 1500,
        height: 500,
        label: 'period',
        datasets: [
          {
            key: 'compPercent',
            label: 'Comp',
            tooltipLabelKey: 'compTooltip',
            decimal: 1,
            borderColor: '#2a78d6',
            backgroundColor: '#2a78d6',
          },
          {
            key: 'nonCompPercent',
            label: 'Non-Comp',
            tooltipLabelKey: 'nonCompTooltip',
            decimal: 1,
            borderColor: '#eb6834',
            backgroundColor: '#eb6834',
          },
        ],
        scaleTypes: {
          y: {
            type: 'percent',
            decimal: 0,
            beginAtZero: true,
          },
        },
        options: {
          scales: {
            x: {
              stacked: true,
              ticks: {
                font: {
                  size: 10,
                },
              },
            },
            y: {
              stacked: true,
              max: 100,
            },
          },
        },
      },
    },
  },
}

export default fwSssBreakdownChart
